
export default function isZipCode(input = '') {
    if (typeof input !== 'string') {
        return false;
    }

    const trimmedInput = input.trim();

    if (trimmedInput) {
        const zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
        return zipCodeRegex.test(trimmedInput);
    }

    return false;
}
